import { jsx as p, jsxs as N } from "react/jsx-runtime";
import * as b from "react";
import M, { useState as z, useEffect as he } from "react";
import { c as Q, a as Se, b as A } from "../index-Dn5fq5RO.js";
import { u as D } from "../index-BwdHfdWj.js";
import { u as ge } from "../index-D-9pS3Rt.js";
import { u as _e } from "../index-BZPx6jYI.js";
import { u as be } from "../index-BuFJZcOe.js";
import { P as B } from "../index-Bo0P2KXg.js";
import { S as G } from "../index-DK6lfaz2.js";
import { Icon as we } from "./Icon.js";
import { c as q } from "../number-DiuiLCOa.js";
function Z(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function ve(e) {
  const t = e + "CollectionProvider", [n, r] = Q(t), [s, c] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), o = (h) => {
    const { scope: S, children: g } = h, m = M.useRef(null), d = M.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ p(s, { scope: S, itemMap: d, collectionRef: m, children: g });
  };
  o.displayName = t;
  const a = e + "CollectionSlot", u = M.forwardRef(
    (h, S) => {
      const { scope: g, children: m } = h, d = c(a, g), y = D(S, d.collectionRef);
      return /* @__PURE__ */ p(G, { ref: y, children: m });
    }
  );
  u.displayName = a;
  const _ = e + "CollectionItemSlot", w = "data-radix-collection-item", i = M.forwardRef(
    (h, S) => {
      const { scope: g, children: m, ...d } = h, y = M.useRef(null), v = D(S, y), l = c(_, g);
      return M.useEffect(() => (l.itemMap.set(y, { ref: y, ...d }), () => void l.itemMap.delete(y))), /* @__PURE__ */ p(G, { [w]: "", ref: v, children: m });
    }
  );
  i.displayName = _;
  function f(h) {
    const S = c(e + "CollectionConsumer", h);
    return M.useCallback(() => {
      const m = S.collectionRef.current;
      if (!m) return [];
      const d = Array.from(m.querySelectorAll(`[${w}]`));
      return Array.from(S.itemMap.values()).sort(
        (l, x) => d.indexOf(l.ref.current) - d.indexOf(x.ref.current)
      );
    }, [S.collectionRef, S.itemMap]);
  }
  return [
    { Provider: o, Slot: u, ItemSlot: i },
    f,
    r
  ];
}
var ee = ["PageUp", "PageDown"], te = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], ne = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, T = "Slider", [F, ye, Ce] = ve(T), [re, dt] = Q(T, [
  Ce
]), [Re, O] = re(T), oe = b.forwardRef(
  (e, t) => {
    const {
      name: n,
      min: r = 0,
      max: s = 100,
      step: c = 1,
      orientation: o = "horizontal",
      disabled: a = !1,
      minStepsBetweenThumbs: u = 0,
      defaultValue: _ = [r],
      value: w,
      onValueChange: i = () => {
      },
      onValueCommit: f = () => {
      },
      inverted: h = !1,
      form: S,
      ...g
    } = e, m = b.useRef(/* @__PURE__ */ new Set()), d = b.useRef(0), v = o === "horizontal" ? xe : Pe, [l = [], x] = Se({
      prop: w,
      defaultProp: _,
      onChange: (C) => {
        var E;
        (E = [...m.current][d.current]) == null || E.focus(), i(C);
      }
    }), H = b.useRef(l);
    function L(C) {
      const P = Ve(l, C);
      k(C, P);
    }
    function me(C) {
      k(C, d.current);
    }
    function pe() {
      const C = H.current[d.current];
      l[d.current] !== C && f(l);
    }
    function k(C, P, { commit: E } = { commit: !1 }) {
      const W = ke(c), $ = Ke(Math.round((C - r) / c) * c + r, W), K = Z($, [r, s]);
      x((V = []) => {
        const I = De(V, K, P);
        if (Te(I, u * c)) {
          d.current = I.indexOf(K);
          const X = String(I) !== String(V);
          return X && E && f(I), X ? I : V;
        } else
          return V;
      });
    }
    return /* @__PURE__ */ p(
      Re,
      {
        scope: e.__scopeSlider,
        name: n,
        disabled: a,
        min: r,
        max: s,
        valueIndexToChangeRef: d,
        thumbs: m.current,
        values: l,
        orientation: o,
        form: S,
        children: /* @__PURE__ */ p(F.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ p(F.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ p(
          v,
          {
            "aria-disabled": a,
            "data-disabled": a ? "" : void 0,
            ...g,
            ref: t,
            onPointerDown: A(g.onPointerDown, () => {
              a || (H.current = l);
            }),
            min: r,
            max: s,
            inverted: h,
            onSlideStart: a ? void 0 : L,
            onSlideMove: a ? void 0 : me,
            onSlideEnd: a ? void 0 : pe,
            onHomeKeyDown: () => !a && k(r, 0, { commit: !0 }),
            onEndKeyDown: () => !a && k(s, l.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: C, direction: P }) => {
              if (!a) {
                const $ = ee.includes(C.key) || C.shiftKey && te.includes(C.key) ? 10 : 1, K = d.current, V = l[K], I = c * $ * P;
                k(V + I, K, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
oe.displayName = T;
var [se, ie] = re(T, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), xe = b.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: r,
      dir: s,
      inverted: c,
      onSlideStart: o,
      onSlideMove: a,
      onSlideEnd: u,
      onStepKeyDown: _,
      ...w
    } = e, [i, f] = b.useState(null), h = D(t, (v) => f(v)), S = b.useRef(void 0), g = ge(s), m = g === "ltr", d = m && !c || !m && c;
    function y(v) {
      const l = S.current || i.getBoundingClientRect(), x = [0, l.width], L = j(x, d ? [n, r] : [r, n]);
      return S.current = l, L(v - l.left);
    }
    return /* @__PURE__ */ p(
      se,
      {
        scope: e.__scopeSlider,
        startEdge: d ? "left" : "right",
        endEdge: d ? "right" : "left",
        direction: d ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ p(
          ae,
          {
            dir: g,
            "data-orientation": "horizontal",
            ...w,
            ref: h,
            style: {
              ...w.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (v) => {
              const l = y(v.clientX);
              o == null || o(l);
            },
            onSlideMove: (v) => {
              const l = y(v.clientX);
              a == null || a(l);
            },
            onSlideEnd: () => {
              S.current = void 0, u == null || u();
            },
            onStepKeyDown: (v) => {
              const x = ne[d ? "from-left" : "from-right"].includes(v.key);
              _ == null || _({ event: v, direction: x ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), Pe = b.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: r,
      inverted: s,
      onSlideStart: c,
      onSlideMove: o,
      onSlideEnd: a,
      onStepKeyDown: u,
      ..._
    } = e, w = b.useRef(null), i = D(t, w), f = b.useRef(void 0), h = !s;
    function S(g) {
      const m = f.current || w.current.getBoundingClientRect(), d = [0, m.height], v = j(d, h ? [r, n] : [n, r]);
      return f.current = m, v(g - m.top);
    }
    return /* @__PURE__ */ p(
      se,
      {
        scope: e.__scopeSlider,
        startEdge: h ? "bottom" : "top",
        endEdge: h ? "top" : "bottom",
        size: "height",
        direction: h ? 1 : -1,
        children: /* @__PURE__ */ p(
          ae,
          {
            "data-orientation": "vertical",
            ..._,
            ref: i,
            style: {
              ..._.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (g) => {
              const m = S(g.clientY);
              c == null || c(m);
            },
            onSlideMove: (g) => {
              const m = S(g.clientY);
              o == null || o(m);
            },
            onSlideEnd: () => {
              f.current = void 0, a == null || a();
            },
            onStepKeyDown: (g) => {
              const d = ne[h ? "from-bottom" : "from-top"].includes(g.key);
              u == null || u({ event: g, direction: d ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), ae = b.forwardRef(
  (e, t) => {
    const {
      __scopeSlider: n,
      onSlideStart: r,
      onSlideMove: s,
      onSlideEnd: c,
      onHomeKeyDown: o,
      onEndKeyDown: a,
      onStepKeyDown: u,
      ..._
    } = e, w = O(T, n);
    return /* @__PURE__ */ p(
      B.span,
      {
        ..._,
        ref: t,
        onKeyDown: A(e.onKeyDown, (i) => {
          i.key === "Home" ? (o(i), i.preventDefault()) : i.key === "End" ? (a(i), i.preventDefault()) : ee.concat(te).includes(i.key) && (u(i), i.preventDefault());
        }),
        onPointerDown: A(e.onPointerDown, (i) => {
          const f = i.target;
          f.setPointerCapture(i.pointerId), i.preventDefault(), w.thumbs.has(f) ? f.focus() : r(i);
        }),
        onPointerMove: A(e.onPointerMove, (i) => {
          i.target.hasPointerCapture(i.pointerId) && s(i);
        }),
        onPointerUp: A(e.onPointerUp, (i) => {
          const f = i.target;
          f.hasPointerCapture(i.pointerId) && (f.releasePointerCapture(i.pointerId), c(i));
        })
      }
    );
  }
), ce = "SliderTrack", le = b.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...r } = e, s = O(ce, n);
    return /* @__PURE__ */ p(
      B.span,
      {
        "data-disabled": s.disabled ? "" : void 0,
        "data-orientation": s.orientation,
        ...r,
        ref: t
      }
    );
  }
);
le.displayName = ce;
var U = "SliderRange", ue = b.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...r } = e, s = O(U, n), c = ie(U, n), o = b.useRef(null), a = D(t, o), u = s.values.length, _ = s.values.map(
      (f) => fe(f, s.min, s.max)
    ), w = u > 1 ? Math.min(..._) : 0, i = 100 - Math.max(..._);
    return /* @__PURE__ */ p(
      B.span,
      {
        "data-orientation": s.orientation,
        "data-disabled": s.disabled ? "" : void 0,
        ...r,
        ref: a,
        style: {
          ...e.style,
          [c.startEdge]: w + "%",
          [c.endEdge]: i + "%"
        }
      }
    );
  }
);
ue.displayName = U;
var Y = "SliderThumb", de = b.forwardRef(
  (e, t) => {
    const n = ye(e.__scopeSlider), [r, s] = b.useState(null), c = D(t, (a) => s(a)), o = b.useMemo(
      () => r ? n().findIndex((a) => a.ref.current === r) : -1,
      [n, r]
    );
    return /* @__PURE__ */ p(Ie, { ...e, ref: c, index: o });
  }
), Ie = b.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, index: r, name: s, ...c } = e, o = O(Y, n), a = ie(Y, n), [u, _] = b.useState(null), w = D(t, (y) => _(y)), i = u ? o.form || !!u.closest("form") : !0, f = be(u), h = o.values[r], S = h === void 0 ? 0 : fe(h, o.min, o.max), g = Ee(r, o.values.length), m = f == null ? void 0 : f[a.size], d = m ? Ne(m, S, a.direction) : 0;
    return b.useEffect(() => {
      if (u)
        return o.thumbs.add(u), () => {
          o.thumbs.delete(u);
        };
    }, [u, o.thumbs]), /* @__PURE__ */ N(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [a.startEdge]: `calc(${S}% + ${d}px)`
        },
        children: [
          /* @__PURE__ */ p(F.ItemSlot, { scope: e.__scopeSlider, children: /* @__PURE__ */ p(
            B.span,
            {
              role: "slider",
              "aria-label": e["aria-label"] || g,
              "aria-valuemin": o.min,
              "aria-valuenow": h,
              "aria-valuemax": o.max,
              "aria-orientation": o.orientation,
              "data-orientation": o.orientation,
              "data-disabled": o.disabled ? "" : void 0,
              tabIndex: o.disabled ? void 0 : 0,
              ...c,
              ref: w,
              style: h === void 0 ? { display: "none" } : e.style,
              onFocus: A(e.onFocus, () => {
                o.valueIndexToChangeRef.current = r;
              })
            }
          ) }),
          i && /* @__PURE__ */ p(
            Me,
            {
              name: s ?? (o.name ? o.name + (o.values.length > 1 ? "[]" : "") : void 0),
              form: o.form,
              value: h
            },
            r
          )
        ]
      }
    );
  }
);
de.displayName = Y;
var Me = (e) => {
  const { value: t, ...n } = e, r = b.useRef(null), s = _e(t);
  return b.useEffect(() => {
    const c = r.current, o = window.HTMLInputElement.prototype, u = Object.getOwnPropertyDescriptor(o, "value").set;
    if (s !== t && u) {
      const _ = new Event("input", { bubbles: !0 });
      u.call(c, t), c.dispatchEvent(_);
    }
  }, [s, t]), /* @__PURE__ */ p("input", { style: { display: "none" }, ...n, ref: r, defaultValue: t });
};
function De(e = [], t, n) {
  const r = [...e];
  return r[n] = t, r.sort((s, c) => s - c);
}
function fe(e, t, n) {
  const c = 100 / (n - t) * (e - t);
  return Z(c, [0, 100]);
}
function Ee(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function Ve(e, t) {
  if (e.length === 1) return 0;
  const n = e.map((s) => Math.abs(s - t)), r = Math.min(...n);
  return n.indexOf(r);
}
function Ne(e, t, n) {
  const r = e / 2, c = j([0, 50], [0, r]);
  return (r - c(t) * n) * n;
}
function Ae(e) {
  return e.slice(0, -1).map((t, n) => e[n + 1] - t);
}
function Te(e, t) {
  if (t > 0) {
    const n = Ae(e);
    return Math.min(...n) >= t;
  }
  return !0;
}
function j(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function ke(e) {
  return (String(e).split(".")[1] || "").length;
}
function Ke(e, t) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
var Be = oe, Oe = le, He = ue, Le = de;
const $e = "_container_1t22y_1", ze = "_label_1t22y_7", Fe = "_sliderContainer_1t22y_13", Ue = "_sliderInnerContainer_1t22y_21", Ye = "_minValue_1t22y_29", je = "_maxValue_1t22y_30", We = "_track_1t22y_44", Xe = "_trackInner_1t22y_52", Ge = "_range_1t22y_60", qe = "_thumb_1t22y_67", Je = "_input_1t22y_100", Qe = "_error_1t22y_118", Ze = "_errorMessage_1t22y_138", R = {
  container: $e,
  label: ze,
  sliderContainer: Fe,
  sliderInnerContainer: Ue,
  minValue: Ye,
  maxValue: je,
  track: We,
  trackInner: Xe,
  range: Ge,
  thumb: qe,
  input: Je,
  error: Qe,
  errorMessage: Ze
}, ft = ({
  min: e,
  max: t,
  value: n,
  divisions: r = 10,
  label: s,
  showInput: c = !0,
  disabled: o = !1,
  onChange: a,
  onError: u
}) => {
  const [_, w] = z(n.toString()), [i, f] = z(
    J({ value: n, min: e, max: t, onError: u })
  ), [h, S] = z(!1), g = Math.max(1, Math.round((t - e) / r)), m = Math.min(Math.max(n, e), t);
  he(() => {
    w(n.toString());
  }, [n]);
  const d = (l) => {
    a(l[0]), w(l[0].toString()), f(void 0);
  }, y = (l) => {
    const x = l.target.value;
    w(x);
  }, v = () => {
    const l = parseInt(_, 10);
    isNaN(l) ? f("Invalid number") : (f(J({ value: l, min: e, max: t, onError: u })), a(l));
  };
  return /* @__PURE__ */ N("div", { className: R.container, "data-disabled": o, children: [
    s && /* @__PURE__ */ p("label", { className: R.label, children: s }),
    /* @__PURE__ */ N("div", { className: R.sliderContainer, children: [
      /* @__PURE__ */ N("div", { className: R.sliderInnerContainer, children: [
        /* @__PURE__ */ p("span", { className: R.minValue, children: q(e) }),
        /* @__PURE__ */ N(
          Be,
          {
            className: `${R.track} ${i ? R.error : ""}`,
            value: [m],
            min: e,
            max: t,
            step: g,
            disabled: o,
            onValueChange: d,
            onPointerDown: () => {
              o || S(!0);
            },
            onPointerUp: () => {
              o || S(!1);
            },
            "aria-label": s,
            children: [
              /* @__PURE__ */ p(Oe, { className: R.trackInner, children: /* @__PURE__ */ p(He, { className: R.range }) }),
              /* @__PURE__ */ p(
                Le,
                {
                  className: R.thumb,
                  "data-dragging": h
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ p("span", { className: R.maxValue, children: q(t) })
      ] }),
      c && /* @__PURE__ */ p(
        "input",
        {
          type: "text",
          className: `${R.input} ${i ? R.error : ""}`,
          value: _,
          disabled: o,
          onChange: y,
          onBlur: v
        }
      )
    ] }),
    i && /* @__PURE__ */ N("div", { className: R.errorMessage, children: [
      we.statusAlertFilled,
      /* @__PURE__ */ p("span", { children: i })
    ] })
  ] });
}, J = (e) => {
  const { value: t, min: n, max: r, onError: s } = e;
  if (t < n || t > r)
    return (s == null ? void 0 : s(t)) ?? `Value must be between ${n} and ${r}`;
};
export {
  ft as Slider
};
